import { NgModule, Type } from '@angular/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NkTimeEditModule } from '../time-edit/time-edit.module';
import { NkDateTimeEdit } from './datetime-edit';

const NK_DIRECTIVES: Type<any>[] = [NkDateTimeEdit];
const modules: Type<any>[] = [NkTimeEditModule, MatDatepickerModule];

@NgModule({
  imports: [...modules],
  declarations: [...NK_DIRECTIVES],
  exports: [...modules, ...NK_DIRECTIVES]
})
export class NkDateTimeEditModule {}
